var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-bg",class:{ 'auth-bg--dimmed': _vm.dimmed }},[_c('div',{staticClass:"auth-bg__base"}),_c('div',{staticClass:"auth-bg__glows"}),_c('div',{staticClass:"auth-bg__panels"}),_c('div',{staticClass:"auth-bg__dots"})])
}
var staticRenderFns = []

export { render, staticRenderFns }